import { render, staticRenderFns } from "./AtlasOptInDialog.vue?vue&type=template&id=23e459f6"
import script from "./AtlasOptInDialog.vue?vue&type=script&lang=ts"
export * from "./AtlasOptInDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports